"use strict";
exports.__esModule = true;
exports.GeoPushpinChart = exports.getGeoChartDimensions = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2023 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var CoreGeoChart_1 = require("./core/CoreGeoChart");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var GeoChart_1 = require("./GeoChart");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var getBuckets = function (props) {
    var color = props.color, segmentBy = props.segmentBy, size = props.size, config = props.config;
    var buckets = [
        sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.SIZE], (size ? [sdk_model_1.disableComputeRatio(size)] : []))),
        sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.COLOR], (color ? [sdk_model_1.disableComputeRatio(color)] : []))),
    ];
    if (GeoChart_1.isGeoPushpinChartProps(props)) {
        var location_1 = props.location;
        buckets.push(sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.LOCATION], (location_1 ? [location_1] : []))));
    }
    else {
        var latitude = props.latitude, longitude = props.longitude;
        buckets.push(sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.LATITUDE], (latitude ? [latitude] : []))));
        buckets.push(sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.LONGITUDE], (longitude ? [longitude] : []))));
    }
    buckets.push(sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.SEGMENT], (segmentBy ? [segmentBy] : []))));
    var tooltipText = config === null || config === void 0 ? void 0 : config[sdk_ui_1.BucketNames.TOOLTIP_TEXT];
    if (tooltipText) {
        buckets.push(sdk_model_1.newBucket(sdk_ui_1.BucketNames.TOOLTIP_TEXT, tooltipText));
    }
    return buckets;
};
/**
 * @internal
 */
function getGeoChartDimensions(def) {
    var buckets = def.buckets;
    var measures = sdk_model_1.bucketsMeasures(buckets);
    var attributes = sdk_model_1.bucketsAttributes(buckets);
    return compact_1["default"]([measures.length > 0 && sdk_model_1.newDimension([sdk_model_1.MeasureGroupIdentifier]), sdk_model_1.newDimension(attributes)]);
}
exports.getGeoChartDimensions = getGeoChartDimensions;
/**
 * Specifies props that are on geo chart props but not on core chart props - these must not be passed
 * down to core chart.
 */
var getNonCoreProps = function (props) {
    var base = [
        "backend",
        "workspace",
        "segmentBy",
        "filters",
        "sortBy",
        "color",
        "size",
    ];
    if (GeoChart_1.isGeoPushpinChartProps(props)) {
        return tslib_1.__spreadArrays(base, ["location"]);
    }
    return tslib_1.__spreadArrays(base, ["longitude", "latitude"]);
};
function GeoPushpinChartInner(props) {
    var _a;
    var backend = props.backend, workspace = props.workspace, sortBy = props.sortBy, filters = props.filters, exportTitle = props.exportTitle, _b = props.execConfig, execConfig = _b === void 0 ? {} : _b;
    var buckets = getBuckets(props);
    var newProps = omit_1["default"](props, getNonCoreProps(props));
    var execution = (_a = backend
        .withTelemetry("GeoPushpinChart", props)
        .workspace(workspace)
        .execution()
        .forBuckets(buckets, filters))
        .withSorting.apply(_a, (sortBy || [])).withDimensions(getGeoChartDimensions)
        .withExecConfig(execConfig);
    return (react_1["default"].createElement(sdk_ui_1.IntlWrapper, { locale: props.locale },
        react_1["default"].createElement(sdk_ui_1.IntlTranslationsProvider, null, function (translationProps) {
            return (react_1["default"].createElement(CoreGeoChart_1.CoreGeoChart, tslib_1.__assign({ intl: translationProps.intl, execution: execution, exportTitle: exportTitle || "GeoPushpinChart" }, newProps)));
        })));
}
var WrappedGeoPushpinChart = sdk_ui_theme_provider_1.withTheme(sdk_ui_1.withContexts(GeoPushpinChartInner));
var GeoPushpinChartLocation = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.location, props.size, props.color, props.segmentBy, props.filters, props.sortBy], props.placeholdersResolutionContext), location = _a[0], size = _a[1], color = _a[2], segmentBy = _a[3], filters = _a[4], sortBy = _a[5];
    return react_1["default"].createElement(WrappedGeoPushpinChart, tslib_1.__assign({}, props, { location: location, size: size, color: color, segmentBy: segmentBy, filters: filters, sortBy: sortBy }));
};
var GeoPushpinChartLatitudeLongitude = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([
        props.longitude,
        props.latitude,
        props.size,
        props.color,
        props.segmentBy,
        props.filters,
        props.sortBy,
    ], props.placeholdersResolutionContext), longitude = _a[0], latitude = _a[1], size = _a[2], color = _a[3], segmentBy = _a[4], filters = _a[5], sortBy = _a[6];
    return (react_1["default"].createElement(WrappedGeoPushpinChart, tslib_1.__assign({}, props, { longitude: longitude, latitude: latitude, size: size, color: color, segmentBy: segmentBy, filters: filters, sortBy: sortBy })));
};
/**
 * @public
 */
exports.GeoPushpinChart = function (props) {
    if (GeoChart_1.isGeoPushpinChartProps(props)) {
        return react_1["default"].createElement(GeoPushpinChartLocation, tslib_1.__assign({}, props));
    }
    return react_1["default"].createElement(GeoPushpinChartLatitudeLongitude, tslib_1.__assign({}, props));
};
//# sourceMappingURL=GeoPushpinChart.js.map